import { createAction, handleActions } from 'redux-actions'
import Moment from 'moment'
import api from '../api'

const GET_DATA_HISTORY = createAction('subscriptions-admin/GET_DATA_HISTORY')
const GET_DATA_HISTORY_SUCCESS = createAction('subscriptions-admin/GET_DATA_HISTORY_SUCCESS')
const GET_DATA_HISTORY_ERROR = createAction('subscriptions-admin/GET_DATA_HISTORY_ERROR')

const initialState = {
  history: [],
  loading: false
}

export default handleActions(
  {
    [GET_DATA_HISTORY]: (state, action) => ({
      ...state,
      history: [],
      loading: true
    }),
    [GET_DATA_HISTORY_SUCCESS]: (state, action) => {
      let events = action.payload
      events.forEach(function (event) {
        // Format DD-MMM-YYYY HH.mm.SS needs to be converted to a valid Moment format to allow sorting
        event.timestamp = Moment(event.timestamp.replace(/\./g, ':')).format('YYYY-MM-DD HH:mm:SS')
      })
      return {
        ...state,
        history: events,
        loading: false
      }
    },
    [GET_DATA_HISTORY_ERROR]: (state, action) => ({
      ...state,
      loading: false
    })
  },
  initialState
)

export const getDataHistory = (imsi, fromDate, toDate) => {
  return dispatch => {
    dispatch(GET_DATA_HISTORY())
    return api
      .get(
        'subscriptionsadmin/getDataHistory',
        imsi,
        `fromDate=${Moment(fromDate).format('YYYY-MM-DD')}&toDate=${Moment(toDate).format('YYYY-MM-DD')}`
      )
      .then(result => {
        dispatch(GET_DATA_HISTORY_SUCCESS(result.dataHistory))
      })
      .catch(error => {
        dispatch(GET_DATA_HISTORY_ERROR())
      })
  }
}



// WEBPACK FOOTER //
// ./src/store/subscriptions-admin/data-history.js